module.exports = __webpack_public_path__ + "img/140ne.2114b034.svg";